import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { AnimatedLogo } from './AnimatedLogo';
import { BrandLogoStrip } from './BrandLogoStrip';
import { ModelStrip } from './ModelStrip';
import { useStore } from '../../contexts/StoreContext';
const ease = [0.23, 1, 0.32, 1] as const;
const speedLines = [{
  top: '18%',
  width: '22vw',
  delay: '0s'
}, {
  top: '42%',
  width: '14vw',
  delay: '1.2s'
}, {
  top: '63%',
  width: '28vw',
  delay: '2.1s'
}, {
  top: '81%',
  width: '18vw',
  delay: '0.6s'
}];
export function Hero() {
  const {
    brands,
    vehicles
  } = useStore();
  const count = vehicles.filter(v => v.published).length;
  return <>
      <ModelStrip data-id="element-663" data-mp="3ry87ljvt0odv" />
      <section className="relative overflow-hidden bg-navy" data-id="element-664" data-mp="3ryrsn9gr3sw4">
        {/* Líneas de velocidad neón */}
        <div aria-hidden className="pointer-events-none absolute inset-0" data-id="element-665" data-mp="1v2apic9tnmqd">
          {speedLines.map((l, i) => <span key={i} className="speed-line absolute left-0 h-px bg-neon-hi/70" style={{
          top: l.top,
          width: l.width,
          animationDelay: l.delay,
          boxShadow: '0 0 8px #1463FF'
        }} data-id="element-666" data-mp="1mwcdafsvdr2d" data-mpi={i} />)}
        </div>
        <div aria-hidden className="absolute inset-x-0 bottom-0 h-px bg-silver-dark/40" data-id="element-667" data-mp="1cyenvoz9xo86" />

        <div className="container-x relative grid items-center gap-8 pb-10 pt-10 lg:grid-cols-[1fr_1fr] lg:gap-6 lg:pb-14 lg:pt-14" data-id="element-668" data-mp="1hx9hllys4x72">
          <div className="order-2 lg:order-1" data-id="element-669" data-mp="25mkcwnxd1zdt">
            <motion.p initial={{
            opacity: 0,
            x: -12
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.3,
            ease
          }} className="inline-flex items-center gap-2 rounded-full border border-silver-dark/40 bg-ink/50 px-3 py-1 text-xs font-semibold tracking-wider text-silver" data-id="element-670" data-mp="25owzjee2cxx7">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-neon-hi" aria-hidden data-id="element-671" data-mp="2olg0vhimlhj7" />
              {brands.length} MARCAS · {count} VERSIONES 0 KM
            </motion.p>
            <h1 className="mt-4 font-display text-[2.6rem] font-black leading-[0.95] tracking-tight sm:text-6xl xl:text-7xl" data-id="element-672" data-mp="33850djcvnupl">
              {['TODAS', 'LAS', 'MARCAS.'].map((w, i) => <motion.span key={w} className="text-metal mr-[0.22em] inline-block" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.3,
              ease,
              delay: 0.06 * i
            }} data-id="element-673" data-mp="2u7oyuffp2xnd" data-mpi={i}>
                  {w}
                </motion.span>)}
              <br data-id="element-674" data-mp="2fgpw3l1jj3bp" />
              <motion.span className="text-glow inline-block text-neon" initial={{
              opacity: 0,
              y: 20,
              filter: 'blur(6px)'
            }} animate={{
              opacity: 1,
              y: 0,
              filter: 'blur(0px)'
            }} transition={{
              duration: 0.3,
              ease,
              delay: 0.25
            }} data-id="element-675" data-mp="2ajpq1a4oy0kl">
                UN SOLO LUGAR.
              </motion.span>
            </h1>
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease,
            delay: 0.35
          }} className="mt-5 max-w-lg text-base text-mist sm:text-lg" data-id="element-676" data-mp="1wm1c6m91jtp1">
              Descubrí tu próximo 0 km, compará alternativas y encontrá la financiación adecuada para vos.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease,
            delay: 0.45
          }} className="mt-7 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-677" data-mp="pzkuirlzpqqf">
              <Link to="/catalogo" className="btn btn-metal group h-12 px-6" data-id="element-678" data-mp="2bb2h7y6o6qu">
                EXPLORAR 0 KM
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-1" aria-hidden data-id="element-679" data-mp="74dyrnuchuaq" />
              </Link>
              <Link to="/simulador" className="btn btn-metal h-12 px-6" data-id="element-680" data-mp="3aro236twicni">
                SIMULAR MI FINANCIACIÓN
              </Link>
              <Link to="/chequeo" className="btn btn-metal h-12 px-6" data-id="element-681" data-mp="2rocf8z5jzhfc">
                CHEQUEO CREDITICIO
              </Link>
            </motion.div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-682" data-mp="31cudb8mg7afa">
            <AnimatedLogo data-id="element-683" data-mp="31enkqq4vxyoc" />
          </div>
        </div>

        <BrandLogoStrip data-id="element-684" data-mp="2wmnnj5g79jvg" />
      </section>
    </>;
}